import { PackageNameEnum } from '@electricjs/core_entity-client';

export const ELIGIBLE_LICENSE_PLAN_NAMES: PackageNameEnum[] = [
  PackageNameEnum.Pro,
  PackageNameEnum.Lyte,
];

// Ordered highest tier to lowest — used to pick the relevant plan when an org
// somehow has more than one Isolved package at once.
export const ISOLVED_PACKAGE_NAMES: PackageNameEnum[] = [
  PackageNameEnum.IsolvedPro,
  PackageNameEnum.IsolvedEssentials,
  PackageNameEnum.IsolvedFree,
];

// TODO(TF-677): replace with gigawatt_setup_assistant entitlement once core-entity ships it
export const FREE_PLAN_PACKAGE_NAMES: PackageNameEnum[] = [
  PackageNameEnum.JustworksFree,
  PackageNameEnum.TrinetFree,
  PackageNameEnum.AdpFree,
  PackageNameEnum.IsolvedFree,
  PackageNameEnum.HrFoundation,
];

// Selectable plans for billing modals
export const SELECTABLE_PLANS: Partial<PackageNameEnum>[] = [
  PackageNameEnum.Quickstart,
  PackageNameEnum.Pro,
  PackageNameEnum.Premier,
  PackageNameEnum.Beta,
  PackageNameEnum.Lyte,
  PackageNameEnum.ProAdp,
  PackageNameEnum.LightAdp,
  PackageNameEnum.AdpFree,
  PackageNameEnum.AdpConnect,
  PackageNameEnum.JustworksFree,
  PackageNameEnum.TrinetFree,
  PackageNameEnum.TrinetPro,
  PackageNameEnum.TrinetEssentials,
  PackageNameEnum.IsolvedFree,
  PackageNameEnum.IsolvedPro,
  PackageNameEnum.IsolvedEssentials,
  PackageNameEnum.HrFoundation,
];

// This may also belong in the DB someday
export const PACKAGE_DESCRIPTION_MAP: Record<string, string> = {
  [PackageNameEnum.Pro]:
    'Full feature access including MDM and device monitoring.',
  [PackageNameEnum.Lyte]:
    'Lightweight feature set without MDM or device monitoring.',
  [PackageNameEnum.ProAdp]:
    'ADP IT Management Pro - Full feature access including MDM and device monitoring for ADP customers.',
  [PackageNameEnum.LightAdp]:
    'ADP IT Management Essentials - Lightweight feature set without MDM or device monitoring for ADP customers.',
  [PackageNameEnum.AdpFree]:
    'ADP IT Management Starter - Basic IT management features for ADP customers.',
  [PackageNameEnum.JustworksFree]:
    'Justworks HR - Free IT management features for Justworks customers.',
  [PackageNameEnum.TrinetFree]:
    'TriNet HR - Free IT management features for TriNet customers.',
  [PackageNameEnum.TrinetPro]:
    'TriNet IT Management Pro - Full feature access including MDM and device monitoring for TriNet customers.',
  [PackageNameEnum.TrinetEssentials]:
    'TriNet IT Management Essentials - Lightweight feature set without MDM or device monitoring for TriNet customers.',
  [PackageNameEnum.IsolvedFree]:
    'isolved IT Management Core - Basic IT management features for isolved customers.',
  [PackageNameEnum.IsolvedPro]:
    'isolved IT Management Pro - Full feature access including MDM and device monitoring for isolved customers.',
  [PackageNameEnum.IsolvedEssentials]:
    'isolved IT Management Essentials - Lightweight feature set without MDM or device monitoring for isolved customers.',
  [PackageNameEnum.HrFoundation]:
    'HR Foundation - Free IT management features for HR Foundation customers.',
};

export const UPGRADE_MESSAGE =
  "You'll need a higher-tier plan to unlock this. Your Customer Success Manager can help you upgrade in no time.";
